/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const devicesQuery = /* GraphQL */ `
  query Devices {
    devices {
      name
      lid
      tags
      type
      group
    }
  }
`;

export const test = /* GraphQL */ `
  query Test {
    test {
      body
    }
  }
`;

export const deviceStatusQuery = `
      query deviceQuery($deviceID: String!) {
        deviceStatus(deviceID: $deviceID) {
          lastSnapshot {
            signedUrl
            time
          }
        }
      }
    `;

export const pipelineExecutionsQuery = /* GraphQL */ `
query pipelineExecutions($deviceID: ID, $status: String, $startDate: String, $endDate: String, $sortDirection: String) {
  pipelineExecutions(deviceID: $deviceID, status: $status, startDate: $startDate, endDate: $endDate, sortDirection: $sortDirection) {
    list {
      createdDate
      analysisStartDate
      analysisEndDate
      pipelineExecutionID
      pipelineID
      pipelineName
      stages {
        algorithmID
        jobID
        status
        version
      }
      status
    }
    nextToken
  }
}
`;

export const getLinesQuery = /* GraphQL */ `
  query getLines($deviceID: String!) {
    getLines(deviceID: $deviceID) {
      name
      points {
        x
        y
      }
    }
  }

`;

export const moviesQuery = /* GraphQL */ `
  query movies($deviceID: ID!, $pageSize: String, $jobID: String, $nextToken: String, $startDate: String, $endDate: String) {
    movies(deviceID: $deviceID, pageSize: $pageSize, nextToken: $nextToken, jobID: $jobID, startDate: $startDate, endDate: $endDate) {
     list {
      SignedMovieUrl
      SignedImageUrl
      DateTime
     }
     nextToken
    }
  }

`;